import { useState, useCallback } from 'react'

export interface UseCreateGroupModalProps {
  onSuccess?: () => void
}

export function useCreateGroupModal({ onSuccess }: UseCreateGroupModalProps = {}) {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  return {
    isOpen,
    openModal,
    closeModal,
    onSuccess
  }
}
